import React, { lazy, Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { Modules } from "./domFactory"

const RenderComponents = ({ contentArea }) => {
  return contentArea.map((block, index) => {
    const module = Modules.find((m) => m.blockName === block.__type__)
    if (module && module.importComponent) {
      const LazyComponent = lazy(module.importComponent)

      return (
        <ErrorBoundary key={index} FallbackComponent={() => null}>
          <Suspense fallback={""}>
            <LazyComponent {...block} />
          </Suspense>
        </ErrorBoundary>
      )
    }

    return null
  })
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.contentArea === nextProps.contentArea
}

export const MemoizedRenderComponents = React.memo(RenderComponents, areEqual)
